import { render } from "./QuanLyLoaiXe.vue?vue&type=template&id=b197c7c6&scoped=true"
import script from "./QuanLyLoaiXe.vue?vue&type=script&lang=js"
export * from "./QuanLyLoaiXe.vue?vue&type=script&lang=js"

import "./QuanLyLoaiXe.vue?vue&type=style&index=0&id=b197c7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b197c7c6"]])

export default __exports__